<template>
  <nav>
    <!-- Public Top Navbar -->
    <v-app-bar color="yellow darken-3 accent-4" dark app class="px-2">
      <v-btn icon @click.stop="mini = !mini" v-if="mini === false">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon @click.stop="mini = !mini" v-else>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <!-- Brand Logo -->
      <v-app-bar-nav-icon class="mr-4 ml-1">
        <v-avatar>
          <v-img src="/img/favicon.png"></v-img>
        </v-avatar>
      </v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase title font-weight-bold">
        <span>Kokkiat Management System</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        text
        rounded
        v-for="tab in tabs"
        :key="tab.text"
        router
        :to="tab.route"
        class="ma-1 hidden-xs-only"
        >{{ tab.text }}</v-btn
      >
      <v-btn text rounded class="ma-1 hidden-xs-only" @click="logout"
        >Logout</v-btn
      >

      <!-- todo: show the drawer on xs screen -->
      <v-app-bar-nav-icon
        class="hidden-sm-and-up"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      color="grey darken-3 accent-4"
      dark
      app
      permanent
      :mini-variant.sync="mini"
    >
      <v-card class="mx-auto" width="300">
        <v-list>
          <v-list-item route to="/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-for="(perrmisionItems_Items, z) in NavBarData.perrmisionItems"
            :key="z"
          >
            <v-icon slot="prependIcon">{{
              perrmisionItems_Items.tagIcon
            }}</v-icon>
            <template v-slot:activator>
              <v-list-item-title>{{
                perrmisionItems_Items.tagheader
              }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(HR_ITEM, i) in perrmisionItems_Items.webPageItems"
              :key="i"
              link
              router
              :to="HR_ITEM.route"
            >
              <v-list-item-icon>
                <v-icon v-text="HR_ITEM.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="HR_ITEM.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { TokenService } from '@/services/storage.service'
import ApiService from '@/services/api.service'

export default {
  name: 'Navbar',
  data: () => ({
    NavBarData: [],
    tabs: [{ text: 'Profile', route: '/profile' }],
    mini: true,
    drawer: false
  }),
  created() {
    this.NavBarInit()
  },
  methods: {
    logout() {
      TokenService.removeToken()
      this.$router.push({ name: 'home' })
    },
    NavBarInit() {
      ApiService.get('/NavBarMenu')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.NavBarData = res.data.respond
              this.loading = false
              this.ready = true
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
              return this.$router.push({ name: 'home' })
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
